import React, {Component} from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {fetchDealers} from "../../../actions/dealersActions";
import {getDealersByBrands} from "../../../selectors/dealers";
import {isLoading} from "../../../selectors/dealerSelection";
import SAInputSearch from "../../../components/common/input/SAInputSearch";
import DealerList from "./DealersList";
import {getSelectedDealer} from "../../../selectors/customerDealer";
import {deleteMyDealer} from "../../../actions/customerDealerActions";
import FieldError from "../../common/input/FieldError";
import './DealerSelection.module.css';
import {Card} from "antd";

class DealerSelection extends Component {

  constructor(props) {
    super(props);
    this.state = {
      filter: null,
    };
  }

  componentDidMount = () => {
    this.props.dispatchFetchDealers();
  }

  fieldMatch = (field, value) => {
    if (!value) {
      return true;
    }
    if (!field) {
      return false;
    }
    return field.toLowerCase().includes(value.toLowerCase());
  }

  getFilteredDealers = () => {
    const {dealers} = this.props;
    if (this.state.filter) {
      const {filter} = this.state;
      return dealers.filter(d =>
        this.fieldMatch(d.dealerName, filter) ||
        this.fieldMatch(d.address.city, filter) ||
        this.fieldMatch(d.address.street1, filter) ||
        this.fieldMatch(d.address.zipcode, filter));
    }
    return dealers;
  }

  searchDealer = (filter) => {
    if (filter.trim() !== '') {
      this.props.dispatchDeleteParamsInformation();
    }
    this.setState({filter});
  };

  render() {
    const {intl: {formatMessage}, ...rest} = this.props;
    const {dealer} = this.props;

    return (
      <Card title={<h3><FormattedMessage id="menu.dealership"/></h3>} bordered={false} style={{width: '100%'}}>
        <div className="wrap">
          <div className="content">
            <SAInputSearch type="text" placeholder={formatMessage({id: 'placeholder.search'})}
                           onSearch={(value) => this.searchDealer(value)}
                           onChange={(value) => this.searchDealer(value.target.value)}
                           style={{width: '35%'}}/>
            <DealerList dataSource={this.getFilteredDealers()} {...rest}/>
            {!dealer &&
              <FieldError error={{message: 'customer.journey.pleaseChoose'}}/>
            }
          </div>
        </div>
      </Card>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchFetchDealers: () => dispatch(fetchDealers()),
  dispatchDeleteParamsInformation: () => dispatch(deleteMyDealer()),
  dispatchSaveParamsInformation: (params) => dispatch({type: 'FETCH.MY_DEALER.REQUEST', params})
});

const mapStateToProps = state => ({
  dealers: getDealersByBrands(state),
  dealer: getSelectedDealer(state),
  loading: isLoading(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(DealerSelection));
